import { MantineThemeOverride } from '@mantine/core';

export type FlexTheme = NonNullable<MantineThemeOverride['components']>['Flex'];

export const Flex: FlexTheme = {
  // todo: define
};
